export const getArrayDifference = (left, right, compareFunction) => {
    const filtered = left.filter(leftValue => !right.some(rightValue => compareFunction(leftValue, rightValue)))
    return filtered && filtered.length > 0 ? filtered : [];
}